import React, { useState } from 'react';
import firebase from 'firebase';
import './Table.scss';
import Row from './Row';
import RowMoblie from './RowMoblie';
import { db } from '../../../firebase';
import { useDataLayerValue } from '../../../DataLayer';
import HeaderTable from './HeaderTable';



function Table(props) {
    let listData = props.listData;
    const [ariaSelected, setAriaSelected] = useState('');
    const [{ playing, lang, song_playing }, dispatch] = useDataLayerValue();
    const handleChangePlaySong = (idSong) => {
        dispatch({
            type: 'SET_PLAYLISTS',
            playlists: listData.map(item => (item.id))
        });
        dispatch({
            type: 'SET_PLAYLIST_ID_NOW',
            playlist_id_now: (props.playListIdNow ? props.playListIdNow.trim() : '')
        });
        if (playing && idSong === song_playing.id) {
            dispatch({
                type: 'SET_PLAYING',
                playing: false
            });
        } else {
            if (idSong) {
                let docRefSong = db.collection("songs").doc(idSong);
                docRefSong.get().then(async function (doc) {
                    if (doc.exists) {
                        let updateSong = { ...doc.data(), id: doc.id };
                        dispatch({
                            type: 'SET_SONG_PLAYING',
                            song_playing: updateSong
                        });
                        dispatch({
                            type: 'SET_PLAYING_LOADING',
                            playing_loading: true
                        });
                        dispatch({
                            type: 'SET_PLAYING',
                            playing: true
                        });
                        //update view of song
                        let docData = {
                            view: parseInt(doc.data()['view']) + 1,
                            updated_at: firebase.firestore.Timestamp.now(),
                        };
                        await db.collection("songs").doc(doc.id).update(docData);
                    } else {
                        // doc.data() will be undefined in this case
                        console.log("No such document detail song!");
                    }
                }).catch(function (error) {
                    console.log("Error getting document detail song");
                });
            }

        }


    };
    const handleSelected = (idSong) => {
        setAriaSelected(idSong);
    };
    return (
        <div className="playlist-table-data-body">
            {window.innerWidth > 600 && <HeaderTable />}
            {listData.map((item, index) => (
                window.innerWidth <= 600 ? (<RowMoblie key={index} index={index + 1} item={item} handleChangePlaySong={handleChangePlaySong} ariaSelected={ariaSelected} handleSelected={handleSelected} />)
                    : (<Row key={index} index={index + 1} item={item} handleChangePlaySong={handleChangePlaySong} ariaSelected={ariaSelected} handleSelected={handleSelected} />)
            ))}
            {/* <div className="see-more-warp">
                <button aria-expanded="false" className="btn-see-more"><div as="div">{lang === "en" ? 'See more' : 'Xem Thêm'}</div></button>
            </div> */}
        </div>

    );
}

export default Table;